import { Activity } from './svg/activity';
import { Airplay } from './svg/airplay';
import { AlertCircle } from './svg/alert-circle';
import { AlertOctagon } from './svg/alert-octagon';
import { AlertTriangle } from './svg/alert-triangle';
import { AlignCenter } from './svg/align-center';
import { AlignJustify } from './svg/align-justify';
import { AlignLeft } from './svg/align-left';
import { AlignRight } from './svg/align-right';
import { Anchor } from './svg/anchor';
import { Aperture } from './svg/aperture';
import { Archive } from './svg/archive';
import { ArrowDownCircle } from './svg/arrow-down-circle';
import { ArrowDownLeft } from './svg/arrow-down-left';
import { ArrowDownRight } from './svg/arrow-down-right';
import { ArrowDown } from './svg/arrow-down';
import { ArrowLeftCircle } from './svg/arrow-left-circle';
import { ArrowLeft } from './svg/arrow-left';
import { ArrowRightCircle } from './svg/arrow-right-circle';
import { ArrowRight } from './svg/arrow-right';
import { ArrowUpCircle } from './svg/arrow-up-circle';
import { ArrowUpLeft } from './svg/arrow-up-left';
import { ArrowUpRight } from './svg/arrow-up-right';
import { ArrowUp } from './svg/arrow-up';
import { AtSign } from './svg/at-sign';
import { Award } from './svg/award';
import { BarChart2 } from './svg/bar-chart-2';
import { BarChart } from './svg/bar-chart';
import { BatteryCharging } from './svg/battery-charging';
import { Battery } from './svg/battery';
import { BellOff } from './svg/bell-off';
import { Bell } from './svg/bell';
import { Bluetooth } from './svg/bluetooth';
import { Bold } from './svg/bold';
import { BookOpen } from './svg/book-open';
import { Book } from './svg/book';
import { Bookmark } from './svg/bookmark';
import { Box } from './svg/box';
import { Briefcase } from './svg/briefcase';
import { Calendar } from './svg/calendar';
import { CameraOff } from './svg/camera-off';
import { Camera } from './svg/camera';
import { Cast } from './svg/cast';
import { CheckCircle } from './svg/check-circle';
import { CheckSquare } from './svg/check-square';
import { Check } from './svg/check';
import { ChevronDown } from './svg/chevron-down';
import { ChevronLeft } from './svg/chevron-left';
import { ChevronRight } from './svg/chevron-right';
import { ChevronUp } from './svg/chevron-up';
import { ChevronsDown } from './svg/chevrons-down';
import { ChevronsLeft } from './svg/chevrons-left';
import { ChevronsRight } from './svg/chevrons-right';
import { ChevronsUp } from './svg/chevrons-up';
import { Chrome } from './svg/chrome';
import { Circle } from './svg/circle';
import { Clipboard } from './svg/clipboard';
import { Clock } from './svg/clock';
import { CloudDrizzle } from './svg/cloud-drizzle';
import { CloudLightning } from './svg/cloud-lightning';
import { CloudOff } from './svg/cloud-off';
import { CloudRain } from './svg/cloud-rain';
import { CloudSnow } from './svg/cloud-snow';
import { Cloud } from './svg/cloud';
import { Code } from './svg/code';
import { Codepen } from './svg/codepen';
import { Codesandbox } from './svg/codesandbox';
import { Coffee } from './svg/coffee';
import { Columns } from './svg/columns';
import { Command } from './svg/command';
import { Compass } from './svg/compass';
import { Copy } from './svg/copy';
import { CornerDownLeft } from './svg/corner-down-left';
import { CornerDownRight } from './svg/corner-down-right';
import { CornerLeftDown } from './svg/corner-left-down';
import { CornerLeftUp } from './svg/corner-left-up';
import { CornerRightDown } from './svg/corner-right-down';
import { CornerRightUp } from './svg/corner-right-up';
import { CornerUpLeft } from './svg/corner-up-left';
import { CornerUpRight } from './svg/corner-up-right';
import { Cpu } from './svg/cpu';
import { CreditCard } from './svg/credit-card';
import { Crop } from './svg/crop';
import { Crosshair } from './svg/crosshair';
import { Database } from './svg/database';
import { Delete } from './svg/delete';
import { Disc } from './svg/disc';
import { DollarSign } from './svg/dollar-sign';
import { DownloadCloud } from './svg/download-cloud';
import { Download } from './svg/download';
import { Droplet } from './svg/droplet';
import { Edit2 } from './svg/edit-2';
import { Edit3 } from './svg/edit-3';
import { Edit } from './svg/edit';
import { ExternalLink } from './svg/external-link';
import { EyeOff } from './svg/eye-off';
import { Eye } from './svg/eye';
import { Facebook } from './svg/facebook';
import { FastForward } from './svg/fast-forward';
import { Feather } from './svg/feather';
import { Figma } from './svg/figma';
import { FileMinus } from './svg/file-minus';
import { FilePlus } from './svg/file-plus';
import { FileText } from './svg/file-text';
import { File } from './svg/file';
import { Film } from './svg/film';
import { Filter } from './svg/filter';
import { Flag } from './svg/flag';
import { FolderMinus } from './svg/folder-minus';
import { FolderPlus } from './svg/folder-plus';
import { Folder } from './svg/folder';
import { Framer } from './svg/framer';
import { Frown } from './svg/frown';
import { Gift } from './svg/gift';
import { GitBranch } from './svg/git-branch';
import { GitCommit } from './svg/git-commit';
import { GitMerge } from './svg/git-merge';
import { GitPullRequest } from './svg/git-pull-request';
import { Github } from './svg/github';
import { Gitlab } from './svg/gitlab';
import { Globe } from './svg/globe';
import { Grid } from './svg/grid';
import { HardDrive } from './svg/hard-drive';
import { Hash } from './svg/hash';
import { Headphones } from './svg/headphones';
import { Heart } from './svg/heart';
import { HelpCircle } from './svg/help-circle';
import { Hexagon } from './svg/hexagon';
import { Home } from './svg/home';
import { Image } from './svg/image';
import { Inbox } from './svg/inbox';
import { Info } from './svg/info';
import { Instagram } from './svg/instagram';
import { Italic } from './svg/italic';
import { Key } from './svg/key';
import { Layers } from './svg/layers';
import { Layout } from './svg/layout';
import { LifeBuoy } from './svg/life-buoy';
import { Link2 } from './svg/link-2';
import { Link } from './svg/link';
import { Linkedin } from './svg/linkedin';
import { List } from './svg/list';
import { Loader } from './svg/loader';
import { Lock } from './svg/lock';
import { LogIn } from './svg/log-in';
import { LogOut } from './svg/log-out';
import { Mail } from './svg/mail';
import { MapPin } from './svg/map-pin';
import { Map } from './svg/map';
import { Maximize2 } from './svg/maximize-2';
import { Maximize } from './svg/maximize';
import { Meh } from './svg/meh';
import { Menu } from './svg/menu';
import { MessageCircle } from './svg/message-circle';
import { MessageSquare } from './svg/message-square';
import { MicOff } from './svg/mic-off';
import { Mic } from './svg/mic';
import { Minimize2 } from './svg/minimize-2';
import { Minimize } from './svg/minimize';
import { MinusCircle } from './svg/minus-circle';
import { MinusSquare } from './svg/minus-square';
import { Minus } from './svg/minus';
import { Monitor } from './svg/monitor';
import { Moon } from './svg/moon';
import { MoreHorizontal } from './svg/more-horizontal';
import { MoreVertical } from './svg/more-vertical';
import { MousePointer } from './svg/mouse-pointer';
import { Move } from './svg/move';
import { Music } from './svg/music';
import { Navigation2 } from './svg/navigation-2';
import { Navigation } from './svg/navigation';
import { Octagon } from './svg/octagon';
import { Package } from './svg/package';
import { Paperclip } from './svg/paperclip';
import { PauseCircle } from './svg/pause-circle';
import { Pause } from './svg/pause';
import { PenTool } from './svg/pen-tool';
import { Percent } from './svg/percent';
import { PhoneCall } from './svg/phone-call';
import { PhoneForwarded } from './svg/phone-forwarded';
import { PhoneIncoming } from './svg/phone-incoming';
import { PhoneMissed } from './svg/phone-missed';
import { PhoneOff } from './svg/phone-off';
import { PhoneOutgoing } from './svg/phone-outgoing';
import { Phone } from './svg/phone';
import { PieChart } from './svg/pie-chart';
import { PlayCircle } from './svg/play-circle';
import { Play } from './svg/play';
import { PlusCircle } from './svg/plus-circle';
import { PlusSquare } from './svg/plus-square';
import { Plus } from './svg/plus';
import { Pocket } from './svg/pocket';
import { Power } from './svg/power';
import { Printer } from './svg/printer';
import { Radio } from './svg/radio';
import { RefreshCcw } from './svg/refresh-ccw';
import { RefreshCw } from './svg/refresh-cw';
import { Repeat } from './svg/repeat';
import { Rewind } from './svg/rewind';
import { RotateCcw } from './svg/rotate-ccw';
import { RotateCw } from './svg/rotate-cw';
import { Rss } from './svg/rss';
import { Save } from './svg/save';
import { Scissors } from './svg/scissors';
import { Search } from './svg/search';
import { Send } from './svg/send';
import { Server } from './svg/server';
import { Settings } from './svg/settings';
import { Share2 } from './svg/share-2';
import { Share } from './svg/share';
import { ShieldOff } from './svg/shield-off';
import { Shield } from './svg/shield';
import { ShoppingBag } from './svg/shopping-bag';
import { ShoppingCart } from './svg/shopping-cart';
import { Shuffle } from './svg/shuffle';
import { Sidebar } from './svg/sidebar';
import { SkipBack } from './svg/skip-back';
import { SkipForward } from './svg/skip-forward';
import { Slack } from './svg/slack';
import { Slash } from './svg/slash';
import { Sliders } from './svg/sliders';
import { Smartphone } from './svg/smartphone';
import { Smile } from './svg/smile';
import { Speaker } from './svg/speaker';
import { Square } from './svg/square';
import { Star } from './svg/star';
import { StopCircle } from './svg/stop-circle';
import { Sun } from './svg/sun';
import { Sunrise } from './svg/sunrise';
import { Sunset } from './svg/sunset';
import { Tablet } from './svg/tablet';
import { Tag } from './svg/tag';
import { Target } from './svg/target';
import { Terminal } from './svg/terminal';
import { Thermometer } from './svg/thermometer';
import { ThumbsDown } from './svg/thumbs-down';
import { ThumbsUp } from './svg/thumbs-up';
import { ToggleLeft } from './svg/toggle-left';
import { ToggleRight } from './svg/toggle-right';
import { Tool } from './svg/tool';
import { Trash2 } from './svg/trash-2';
import { Trash } from './svg/trash';
import { Trello } from './svg/trello';
import { TrendingDown } from './svg/trending-down';
import { TrendingUp } from './svg/trending-up';
import { Triangle } from './svg/triangle';
import { Truck } from './svg/truck';
import { Tv } from './svg/tv';
import { Twitch } from './svg/twitch';
import { Twitter } from './svg/twitter';
import { Type } from './svg/type';
import { Umbrella } from './svg/umbrella';
import { Underline } from './svg/underline';
import { Unlock } from './svg/unlock';
import { UploadCloud } from './svg/upload-cloud';
import { Upload } from './svg/upload';
import { UserCheck } from './svg/user-check';
import { UserMinus } from './svg/user-minus';
import { UserPlus } from './svg/user-plus';
import { UserX } from './svg/user-x';
import { User } from './svg/user';
import { Users } from './svg/users';
import { VideoOff } from './svg/video-off';
import { Video } from './svg/video';
import { Voicemail } from './svg/voicemail';
import { Volume1 } from './svg/volume-1';
import { Volume2 } from './svg/volume-2';
import { VolumeX } from './svg/volume-x';
import { Volume } from './svg/volume';
import { Watch } from './svg/watch';
import { WifiOff } from './svg/wifi-off';
import { Wifi } from './svg/wifi';
import { Wind } from './svg/wind';
import { XCircle } from './svg/x-circle';
import { XOctagon } from './svg/x-octagon';
import { XSquare } from './svg/x-square';
import { X } from './svg/x';
import { Youtube } from './svg/youtube';
import { ZapOff } from './svg/zap-off';
import { Zap } from './svg/zap';
import { ZoomIn } from './svg/zoom-in';
import { ZoomOut } from './svg/zoom-out';

export const allIcons = {
  Activity,
  Airplay,
  AlertCircle,
  AlertOctagon,
  AlertTriangle,
  AlignCenter,
  AlignJustify,
  AlignLeft,
  AlignRight,
  Anchor,
  Aperture,
  Archive,
  ArrowDownCircle,
  ArrowDownLeft,
  ArrowDownRight,
  ArrowDown,
  ArrowLeftCircle,
  ArrowLeft,
  ArrowRightCircle,
  ArrowRight,
  ArrowUpCircle,
  ArrowUpLeft,
  ArrowUpRight,
  ArrowUp,
  AtSign,
  Award,
  BarChart2,
  BarChart,
  BatteryCharging,
  Battery,
  BellOff,
  Bell,
  Bluetooth,
  Bold,
  BookOpen,
  Book,
  Bookmark,
  Box,
  Briefcase,
  Calendar,
  CameraOff,
  Camera,
  Cast,
  CheckCircle,
  CheckSquare,
  Check,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  ChevronsDown,
  ChevronsLeft,
  ChevronsRight,
  ChevronsUp,
  Chrome,
  Circle,
  Clipboard,
  Clock,
  CloudDrizzle,
  CloudLightning,
  CloudOff,
  CloudRain,
  CloudSnow,
  Cloud,
  Code,
  Codepen,
  Codesandbox,
  Coffee,
  Columns,
  Command,
  Compass,
  Copy,
  CornerDownLeft,
  CornerDownRight,
  CornerLeftDown,
  CornerLeftUp,
  CornerRightDown,
  CornerRightUp,
  CornerUpLeft,
  CornerUpRight,
  Cpu,
  CreditCard,
  Crop,
  Crosshair,
  Database,
  Delete,
  Disc,
  DollarSign,
  DownloadCloud,
  Download,
  Droplet,
  Edit2,
  Edit3,
  Edit,
  ExternalLink,
  EyeOff,
  Eye,
  Facebook,
  FastForward,
  Feather,
  Figma,
  FileMinus,
  FilePlus,
  FileText,
  File,
  Film,
  Filter,
  Flag,
  FolderMinus,
  FolderPlus,
  Folder,
  Framer,
  Frown,
  Gift,
  GitBranch,
  GitCommit,
  GitMerge,
  GitPullRequest,
  Github,
  Gitlab,
  Globe,
  Grid,
  HardDrive,
  Hash,
  Headphones,
  Heart,
  HelpCircle,
  Hexagon,
  Home,
  Image,
  Inbox,
  Info,
  Instagram,
  Italic,
  Key,
  Layers,
  Layout,
  LifeBuoy,
  Link2,
  Link,
  Linkedin,
  List,
  Loader,
  Lock,
  LogIn,
  LogOut,
  Mail,
  MapPin,
  Map,
  Maximize2,
  Maximize,
  Meh,
  Menu,
  MessageCircle,
  MessageSquare,
  MicOff,
  Mic,
  Minimize2,
  Minimize,
  MinusCircle,
  MinusSquare,
  Minus,
  Monitor,
  Moon,
  MoreHorizontal,
  MoreVertical,
  MousePointer,
  Move,
  Music,
  Navigation2,
  Navigation,
  Octagon,
  Package,
  Paperclip,
  PauseCircle,
  Pause,
  PenTool,
  Percent,
  PhoneCall,
  PhoneForwarded,
  PhoneIncoming,
  PhoneMissed,
  PhoneOff,
  PhoneOutgoing,
  Phone,
  PieChart,
  PlayCircle,
  Play,
  PlusCircle,
  PlusSquare,
  Plus,
  Pocket,
  Power,
  Printer,
  Radio,
  RefreshCcw,
  RefreshCw,
  Repeat,
  Rewind,
  RotateCcw,
  RotateCw,
  Rss,
  Save,
  Scissors,
  Search,
  Send,
  Server,
  Settings,
  Share2,
  Share,
  ShieldOff,
  Shield,
  ShoppingBag,
  ShoppingCart,
  Shuffle,
  Sidebar,
  SkipBack,
  SkipForward,
  Slack,
  Slash,
  Sliders,
  Smartphone,
  Smile,
  Speaker,
  Square,
  Star,
  StopCircle,
  Sun,
  Sunrise,
  Sunset,
  Tablet,
  Tag,
  Target,
  Terminal,
  Thermometer,
  ThumbsDown,
  ThumbsUp,
  ToggleLeft,
  ToggleRight,
  Tool,
  Trash2,
  Trash,
  Trello,
  TrendingDown,
  TrendingUp,
  Triangle,
  Truck,
  Tv,
  Twitch,
  Twitter,
  Type,
  Umbrella,
  Underline,
  Unlock,
  UploadCloud,
  Upload,
  UserCheck,
  UserMinus,
  UserPlus,
  UserX,
  User,
  Users,
  VideoOff,
  Video,
  Voicemail,
  Volume1,
  Volume2,
  VolumeX,
  Volume,
  Watch,
  WifiOff,
  Wifi,
  Wind,
  XCircle,
  XOctagon,
  XSquare,
  X,
  Youtube,
  ZapOff,
  Zap,
  ZoomIn,
  ZoomOut,
};
